import { render, staticRenderFns } from "./TheSideNavToggle.vue?vue&type=template&id=19640bb8&scoped=true&"
var script = {}
import style0 from "./TheSideNavToggle.vue?vue&type=style&index=0&id=19640bb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19640bb8",
  null
  
)

export default component.exports